<template>
  <div>
    <ld-header @click-right="submit">
      <span
        slot="right"
        class="main-color"
      >
        {{ $t('B010','保存') }}
      </span>
      
      修改密码
    </ld-header>
    
    <van-cell-group>
      <van-field
        v-model="oldPassword"
        label="当前密码"
        ref="password"
        type="password"
        placeholder="请输入当前密码"
        autofocus
        required
      />
      <van-field
        v-model="password"
        label="新密码"
        ref="password"
        type="password"
        placeholder="请输入当前密码"
        autofocus
        required
      />
      <van-field
        v-model="confirmPassword"
        label="确认新密码"
        ref="password"
        type="password"
        placeholder="请输入当前密码"
        autofocus
        required
      />
    </van-cell-group>
  </div>
</template>

<script>
import { CellGroup, Field, Button } from 'vant'
import { validators } from 'Utils/valid'
import { localget } from 'Utils/storage.js'

export default {
  name: 'ModifyPassword',
  components: {
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Button.name]: Button
  },
  data() {
    return {
      oldPassword: '',
      password: '',
      confirmPassword: ''
    }
  },
  methods: {
    async submit() {
      if (localget('AutoLogin').password !== this.oldPassword) {
        this.$validErrorTips('当前密码不正确')
        return
      }
      
      if (!validators.password(this.password).valid) {
        this.$validErrorTips(validators.password(this.password).msg)
        return
      }
      
      if (this.password !== this.confirmPassword) {
        this.$validErrorTips('两次密码不相符')
        return
      }
      
      try {
        await this.$api['user/vipEmpEditPwd']({
          oldPwd: this.oldPassword,
          pwd: this.password
        })
        var self=this
        this.$dialog.alert({ message: '修改成功' }).then(() => {
          this.$store.dispatch('loginOut').then(()=>{
            self.$router.push('/login')
          }).catch(()=>{
            self.$router.push('/login')
          })
        })

      } catch (error) {
        throw error
      }
    }
  }
}
</script>